/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  SELECTION,
  PAGELENGTHS
}                                  from 'g3w-constants';
import Component                   from 'g3w-component';
import ApplicationState            from 'store/application';
import Field                       from 'components/FieldG3W.vue';
import GUI                         from 'services/gui';
import DataRouterService           from 'services/data';
import { debounce }                from 'utils/debounce';
import { promisify }               from 'utils/promisify';
import { getCatalogLayerById }     from 'utils/getCatalogLayerById';
import { gettext as _ }            from 'g3w-i18n';

function toOLGeom(geom) {
  return new (Object.entries({
    'MultiPolygon': ol.geom.MultiPolygon,
    'MultiLine':    ol.geom.MultiLineString,
    'MultiPoint':   ol.geom.MultiPoint,
    'Polygon':      ol.geom.Polygon,
    'Line':         ol.geom.LineString,
    'Point':        ol.geom.Point,
    '':             ol.geom.Point, // fallback
  }).find(o => geom.type.startsWith(o[0])))[1](geom.coordinates);
}

function _createFeatureForSelection(f) {
  return {
    id: f.id,
    feature: {
      attributes: f.attributes || f.properties,
      geometry:   f.geometry ? toOLGeom(f.geometry) : f.geometry,
    },
  }
}

const __vue_script__ = {

  name: "G3WTable",

  components: {
    Field
  },

  data() {
    const layer = getCatalogLayerById(this.$options.layerId);

    return {
      layer,
      state: {
        features:      [],
        headers:       [null, ...layer.getTableHeaders()], // first value is `null` for DataTable purpose (used to add a custom input selector)
        geometry:      true,
        allfeatures:   0,
        selectAll:     false,
        nofilteredrow: false,
        show_tools:    false,
        geolayer: {
          active:    false,
          in_bbox:   undefined,
        },
      },
      // when the current layer is: alphanumerical + not child of relation + relation has geometry
      relations: (layer.isGeoLayer() ? [] : layer.getRelations().getArray())
        .map(relation => [relation, getCatalogLayerById(relation.getFather())])
        .filter(([relation, father]) => layer.getId() !== relation.getFather() && father.isGeoLayer())
        .map(([relation, father]) => ({
          layer:         father,
          father_fields: relation.getFatherField(), // NB: since g3w-admin@v3.7.0 this is an Array value.
          fields:        relation.getChildField(),  // NB: since g3w-admin@v3.7.0 this is an Array value.
          features:      {},
        })),
      filter:              [],
      has_map:             true,
      async_highlight:     () => {},
      getAll:              false,
      search:              {},
      firstCall:           true,
      map_bbox:            { key: null, cb: null },
      disableSelectAll:    false,
    };
  },
  
  computed: {

    /**
     * @returns { Boolean } In case of filter without pagination active
     * 
     * @since 4.0.0
     */
    show_on_active_filter() {
      return !(this.layer.state.filter.pagination && (this.layer.state.filter.active || !this.layer.state.selectionFids.has('__ALL__')));
    },

    current_layout() {
      return ApplicationState.gui.layout[ApplicationState.gui.layout.__current];
    }

  },

  methods: {

    /**
     * @param layer
     * 
     * @since 3.11.0
     */
    toggleFilterToken(layer) {
      // get selection features in case of autofilter + pagination
      if (layer.state.filter.active && !layer.state.selectionFids.has('__ALL__')) {
        this.state.selectAll = false;
      }
      layer.toggleFilterToken();
    },

    /**
     * @param feature
     * 
     * @since 3.10.0
     */
    editFeature(feature) {
      $('.tooltip').remove();
      GUI
        .getService('queryresults')
        .editFeature({ layer: { id: this.layer.getId() }, feature })
    },

    /**
     * @param feature
     * 
     * @since 3.10.0
     */
     async openForm(feature) {
      $('.tooltip').remove();
      try {
        await promisify(
          DataRouterService.getData('search:fids', {
            inputs: {
              layer:     this.layer,
              fids:      [feature.id],
              formatter: 1
            }
          })
        );
        // zoom to feature
        if (feature.geometry) {
          GUI.getService('map').zoomToGeometry(toOLGeom(feature.geometry));
        }
      } catch (e) {
       console.warn(e); 
      }
    },

    async getDataFromBBOX() {
      const map = GUI.getService('map');

      this.state.geolayer.active = !this.state.geolayer.active;

      const is_active = this.state.geolayer.active;

      if (is_active) {
        this.map_bbox.cb = () => {
          this.state.geolayer.in_bbox = this.state.geolayer.active ? map.getMapBBOX().join(',') : undefined;
          $(this.$refs.attribute_table).DataTable().ajax.reload();
        };
      }

      if (is_active) {
        this.map_bbox.key = map.getMap().on('moveend', this.map_bbox.cb);
      }

      if (this.map_bbox.cb) {
        this.map_bbox.cb();
      }

      // reset bbox event handler
      if (!is_active) {
        ol.Observable.unByKey(this.map_bbox.key);
        this.map_bbox.key = null;
        this.map_bbox.cb  = null;
      }
    },

    async inverseSelection() {
      // get all features
      if (!this.getAll) {
        await this.getFeatures({ formatter: 1 })
      }
      //invert select attribute from current loaded features
      this.state.features.forEach(f => f.selected = !f.selected);
      //Invert selection
      this.layer.invertSelectionFids();
      //set state of all features on table
      this.state.selectAll = this.layer.getSelectionFids().has(SELECTION.ALL) || this.state.features.every(f => f.selected);
    },

    async selectAllRows() {

      // inverse selection (all)
      this.state.selectAll = !this.state.selectAll;

      // wait for DOM changes
      await this.$nextTick();

      // check if has columns filter
      const filter = this.filter.length > 0;

      // get all features when any kind of filter is unset
      if (!filter && this.state.selectAll && !this.getAll) {
        await this.getFeatures({ formatter: 1 }); 
      }

      // no filter
      if (!filter) {
        this.state.features.forEach(f => f.selected = this.state.selectAll)                      // select each feature
        await this.layer[this.state.selectAll ? 'setSelectionFidsAll' : 'clearSelectionFids'](); // toggle selection (filter token)
      }

      // column filter
      if (filter && this.state.selectAll && this.state.allfeatures > this.state.featurescount) {
        await this.layer.clearSelectionFids();                                                   // clear selection ids
        this.state.selectAll = true;                                                             // force selectAll
        this.state.features.splice(0);                                                           // reset features
        await this.$nextTick();                                                                  // wait for DOM changes
        (await this.getFeatures({ field: this.search.field, formatter: 1 }) || [])
          .forEach(f => {
            f.selected = this.state.selectAll;
            if (f.geometry) {
              this.layer.addOlSelectionFeature(_createFeatureForSelection(f));
            }
            this.layer.includeSelectionFid(f.id);
            this.state.features.push({
              id:         f.id,
              selected:   f.selected,                                                            // whether filter token comes from a pagination
              attributes: f.attributes || f.properties,
              geometry  : f.geometry
          });
        })
      }

      /** @FIXME add description */
      if (filter && this.state.selectAll && this.state.allfeatures <= this.state.featurescount) {
        this.state
          .features
          .filter(f => this.filter.includes(f.id))
          .forEach(f => {
            f.selected = true;
            this.layer.includeSelectionFid(f.id);
          });
      }

      /** @FIXME add description */
      if (filter && !this.state.selectAll) {
        this.state.features.forEach(f => f.selected = false);
        await this.layer.clearSelectionFids();
      }

      this.state.show_tools = this.state.features.some(f => f.selected);
    },

    /**
     * Highlight or zoom to feature
     * 
     * @param {*} feature
     * @param {*} zoom    - whether zoom to feature
     */
    async highlight(feature, zoom = true) {
      const map = GUI.getService('map');

      // no feature or no feature geometry → clear highlight
      if (!feature || !feature.geometry) {
        return map.clearHighlightGeometry();
      }

      this.async_highlight = () => {
        map.clearHighlightGeometry();
        map.highlightGeometry(feature.geometry, { zoom, duration: Infinity })
      };

      // sync highlight
      if (feature.geometry && this.has_map) {
        return this.async_highlight();
      }

      // skip when there is no relation features geometry
      if (feature.geometry || (!feature.geometry && !this.relations.length > 0)) {
        return;
      }

      // zoom and highlight relation features 
      const features     = [];
      const field_values = []; // check if add or not

      (await Promise.allSettled(this.relations.flatMap(({ layer, father_fields, fields }) => {
        const values = fields.map(f => feature.attributes[f]);
        field_values.push(values);
        return zoom
          ? DataRouterService.getData('search:features', {
              inputs: {
                layer,
                formatter: 1,
                filter: father_fields.map((field, i) => `${field}|eq|${encodeURIComponent(values[i])}`).join('|AND,'),
              },
              outputs: false, // just a request not show on result
            })
          : [];
      })))
        .forEach((response, index) => {
          if ('fulfilled' === response.status) {
            const relation = this.relations[index];
            const k        = field_values[index].join('__'); // create a unique feature key
            const data     = response.value && response.value.data[0];
            if (undefined === relation.features[k]) {
              relation.features[k] = data && data.features || [];
            }
            features.push(...relation.features[k]);
          }
          if (zoom) {
            map.zoomToFeatures(features, { highlight: true });
          } else {
            map.highlightFeatures(features);
          }
        });
    },

    /**
     * Add or Remove feature to selection
     */
    select(feature) {
      feature.selected      = !feature.selected;                                                // inverse selected feature
      this.state.selectAll  = this.state.features.every(f => f.selected); 
      this.layer[feature.selected ? 'includeSelectionFid' : 'excludeSelectionFid'](`${feature.id}`); //string
      this.state.show_tools = this.layer.getSelectionFids().size > 0;                           // show tools based on selected state
    },

    async resize() {
      await this.$nextTick();
      const table = this.$el.querySelector('div.dataTables_scrollBody');
      if (table) {
        table.style.height = GUI.isMobile() ? '100%' : (
            (ApplicationState.viewport.content.sizes.height)                              // table height
          - (this.$el.querySelector('div.dataTables_scrollHeadInner')?.clientHeight || 0) // table header height
          - 100
        ) + 'px';
      }
      // adjust columns when resize
      $(this.$refs.attribute_table).DataTable().columns.adjust();
    },

    async getFeatures(params) {
      try {
        GUI.disableContent(true);
        GUI.setLoadingContent(true);

        const data     = await promisify(this.layer.getDataTable(params || {}));
        const is_valid = this.layer.isGeoLayer() && data.features;

        if (is_valid && !params) {
          const loaded_features = this.state.features.map(f => f.id);
          data.features
            .filter(f => f.geometry && !loaded_features.includes(f.id))
            .forEach(f => this.layer.addOlSelectionFeature(_createFeatureForSelection(f)));
          this.getAll = true;
        }

        if (is_valid) {
          return data.features;
        }
      } catch(e) {
        console.warn(e);
        return Promise.reject();
      } finally {
        GUI.setLoadingContent(false);
        GUI.disableContent(false);
      }
    },

    /**
     * Get DataTable layer
     * 
     * @param data.start
     * @param data.order
     * @param data.length
     * @param data.columns
     * @param data.search
     * 
     * @returns {Promise<{{ data: [], recordsTotal: number, recordsFiltered: number }}>}
     */
    async getData({
      start     = 0,
      order     = [],
      length    = this.layer.getAttributeTablePageLength() || PAGELENGTHS[1],
      columns   = [],
      search    = { value: null },
    } = {}) {
      GUI.setLoadingContent(true);
      GUI.disableContent(true);

      this.layer.setAttributeTablePageLength(length);

      // no headers are set
      if (0 === this.state.headers.length) {
        return {
          data:            [],
          recordsTotal:    0,
          recordsFiltered: 0
        };
      }

      // reset features
      this.state.features.splice(0);

      await this.$nextTick();


      if (0 === order.length) {
        order.push({ column: 1, dir: 'asc', });
      }

      this.search = {
        field:     columns.filter(c => c.search && c.search.value).map((c, i, arr) => `${c.name}|ilike|${c.search.value}${i < arr.length - 1 ? '|AND' : ''}`).join(',') || undefined,
        page:      (start === 0 || this.layer.state.filter.active) ? 1 : (start/length) + 1, // get current page
        page_size: length,
        search:    search.value && search.value.length > 0 ? search.value : null,
        in_bbox:   this.state.geolayer.in_bbox,
        ordering:  ('asc' === order[0].dir ? '' : '-') + this.state.headers[order[0].column].name,
        formatter: 1,
      };

      try {
        const data = await promisify(
          this.layer.getDataTable(this.search)
        );

        this.state.allfeatures   = data.count;
        this.state.featurescount = (data.features || []).length;

        // add features
        this.state.features.push(
          ...(data.features || []).map(f => {
            f.selected = this.state.selectAll || this.layer.state.filter.active || this.layer.hasSelectionFid(f.id)
            const has_geometry = this.layer.isGeoLayer() && f.geometry;
            if (has_geometry && !this.layer.getOlSelectionFeature(f.id)) {
              this.layer.addOlSelectionFeature(_createFeatureForSelection(f));
              if (f.selected) { this.layer.includeSelectionFid(f.id) };
            }

            return {
              id:         f.id,
              selected:   f.selected,
              attributes: f.attributes || f.properties,
              geometry:   has_geometry && f.geometry || undefined
            };
          })
        );

        this.state.show_tools = this.layer.state.filter.active || this.layer.getSelectionFids().size > 0;
        this.state.selectAll  = this.layer.state.filter.active || this.layer.state.selectionFids.has('__ALL__') || (this.state.selectAll && this.state.features.every(f => f.selected));

        return {
          data:            this.state.features.map(f => [null].concat(this.state.headers.filter(h => h).map(h => { h.value = (f.attributes || f.properties)[h.name]; return h.value; }))),
          recordsFiltered: data.count,
          recordsTotal:    data.count,
          filter:          this.state.features.map(f => f.id),
        };
      } catch(e) {
        console.warn(e);
        GUI.notify.error(_("info.server_error"));
        return Promise.reject(e);
      } finally {
        GUI.setLoadingContent(false);
        GUI.disableContent(false);
      }
    },

    unSelectAll() {
      this.state.features.forEach(f => f.selected = false);
      this.state.show_tools = false;
      this.state.selectAll  = false;
    },

    onGUIContent(opts = {}) {
      this.has_map = (100 !== opts.perc);
    },

    /**
     * Reload data from server
     * 
     * @since 3.10.0
     */
    filterChangeHandler() {
      $(this.$refs.attribute_table).DataTable().ajax.reload();
    },

  },

  /**
   * TableService Class
   * 
   * ORIGINAL SOURCE: src/app/gui/table/tableservice.js@v3.9.3
   */
  async created() {

    GUI.on('resize', this.resize);

    this.currentFilter = null

    this.unSelectAll  = this.unSelectAll.bind(this);
    this.onGUIContent = this.onGUIContent.bind(this)

    GUI.onbefore('setContent',         this.onGUIContent);
    this.layer.on('unselectionall',    this.unSelectAll);
    this.layer.on('filtertokenchange', this.filterChangeHandler);

    GUI.closeSideBar();

    GUI.showContent({
      content: new Component({
        id:                'openattributetable',
        service:           { state: this.state },
        internalComponent: this,
      }),
      split: GUI.isMobile() ? 'h': 'v',
      push: false,
      title: this.layer.getTitle(),
      text:  true,
    });

    if (this.isMobile()) {
      GUI.hideSidebar();
    }
  },

  async mounted() {
  
    // un-toggle map controls
    this.last_map_control = GUI.getService('map').getMapControls().find(c => c.control.isToggled && c.control.isToggled());
    if (this.last_map_control) {
        this.last_map_control.control.toggle();
    }

    await this.$nextTick();

    // resolve data from server
    let resolve;
    // store columns index value search
    const filterColumns = {};

    // set data table
    const table = $(this.$refs.attribute_table).DataTable({
      ajax: debounce(async (opts, cb) => {
        GUI.disableContent(true);
        try {
          const data = await this.getData(opts);
          cb(data);
          this.disableSelectAll = 0 === this.state.features.length;
          if (resolve) {
            resolve(data.filter);
          }
          await this.$nextTick();
          table.columns.adjust();
        } catch(e) {
          console.warn(e);
        }
        this.resize()
      }, 800),
      bSortCellsTop:  true,
      columns:        this.state.headers,
      columnDefs:     [{ orderable: false, searchable: false, targets: 0, width: '1%' }],
      deferLoading:   this.state.allfeatures,
      dom:            'frt<"#g3w-table-toolbar">lip',
      lengthMenu:     PAGELENGTHS,
      order:          [ 1, 'asc' ],
      pageLength:     this.layer.getAttributeTablePageLength() || PAGELENGTHS[1],
      processing:     false,
      responsive:     true,
      scrollCollapse: true,
      scrollX:        true,
      serverSide:     true,
      sSearch:        false,
    });

    this.changeColumn = debounce(async (e, i) => {
      const value = e.target.value.trim();
      table.one('draw', async() => {
        filterColumns[i]      = value;
        this.disableSelectAll = 0 === this.state.features.length;
        this.filter           = Object.values(filterColumns).find(f => f)
          ? await (new Promise(res => resolve = res))
          : [];
      })
      table.columns(i).search(value).draw();
    });

    // move "table_toolbar" DOM element under datatable 
    const fragment = document.createDocumentFragment();
    fragment.appendChild(this.$refs.table_toolbar);
    document.getElementById('g3w-table-toolbar').appendChild(fragment);

    // move "dataTables_info" and "dataTables_filter" before header action tools
    document.querySelector('#g3w-view-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', document.querySelector('.dataTables_info'));
    document.querySelector('#g3w-view-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', document.querySelector('.dataTables_filter'));

    // hide datatable rows → show only our custom "table_body"
    document.getElementById('table_body_attributes').remove();

    table.ajax.reload();
  },

  async beforeDestroy() {

    // restore any previous active map control
    if (this.last_map_control && !this.last_map_control.control.isToggled()) {
     this.last_map_control.control.toggle();
    }

    this.last_map_control = null;

    this.layer.off('unselectionall',    this.unSelectAll);
    this.layer.off('filtertokenchange', this.filterChangeHandler);

    // reset bbox event handler
    ol.Observable.unByKey(this.map_bbox.key);
    this.map_bbox.key = null;
    this.map_bbox.cb  = null;

    this.highlight();

    if (!this.has_map) {
      setTimeout(() => {
        this.async_highlight();
        this.has_map         = true;
        this.async_highlight = () => {};
      });
    }

    GUI.off('resize', this.resize);

    document.querySelector('#g3w-view-content .dataTables_info').remove();
    document.querySelector('#g3w-view-content .dataTables_filter').remove();
    $(this.$refs.attribute_table).DataTable().destroy(true);
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"open_attribute_table"}},[_c('div',{ref:"table_toolbar",staticStyle:{"display":"flex","justify-content":"space-between","padding":"1px"}},[(_vm.layer.isGeoLayer())?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.geolayer.active && _vm.current_layout.rightpanel.height_100),expression:"state.geolayer.active && current_layout.rightpanel.height_100"},{name:"t-tooltip",rawName:"v-t-tooltip",value:('Update results when map moves'),expression:"'Update results when map moves'"}],staticClass:"skin-color action-button",class:[ _vm.$fa('map'), _vm.state.geolayer.active ? 'toggled' : '' ],attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.getDataFromBBOX.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.show_tools),expression:"state.show_tools"},{name:"t-tooltip",rawName:"v-t-tooltip",value:('Invert Selection'),expression:"'Invert Selection'"}],staticClass:"skin-color action-button",class:_vm.$fa('clear'),attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.layer.clearSelectionFids()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.show_tools),expression:"state.show_tools"},{name:"t-tooltip",rawName:"v-t-tooltip",value:('Invert Selection'),expression:"'Invert Selection'"}],staticClass:"skin-color action-button",class:[ _vm.$fa('invert'), _vm.layer.state.filter.active ? 'g3w-disabled': '' ],attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.inverseSelection.apply(null, arguments)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.show_tools && _vm.show_on_active_filter),expression:"state.show_tools && show_on_active_filter"},{name:"t-tooltip",rawName:"v-t-tooltip",value:('Enable/Disable filter'),expression:"'Enable/Disable filter'"}],staticClass:"skin-color action-button",class:[ _vm.$fa('filter'), _vm.layer.state.filter.active ? 'toggled' : '' ],attrs:{"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFilterToken(_vm.layer)}}})]),_vm._v(" "),(_vm.state.headers.length)?_c('table',{ref:"attribute_table",staticClass:"table table-striped row-border compact nowrap",attrs:{"id":"layer_attribute_table"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_vm._l((_vm.state.headers),function(header,i){return (i > 0)?_c('th',[_vm._v(_vm._s(header.label))]):_vm._e()})],2),_vm._v(" "),_c('tr',[_c('th',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disableSelectAll),expression:"disableSelectAll"}]},[_c('label',{on:{"click":_vm.selectAllRows}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.state.selectAll && _vm.state.features.length > 0}})])]),_vm._v(" "),_vm._l((_vm.state.headers),function(header,i){return (i > 0)?_c('th',[_c('input',{staticClass:"form-control column-search",attrs:{"type":"text","placeholder":header.name,"title":'search by ' + header.name},on:{"keyup":function($event){return _vm.changeColumn($event, i)}}})]):_vm._e()})],2)]),_vm._v(" "),_c('tbody',{attrs:{"id":"table_body_attributes","hidden":""}}),_vm._v(" "),_c('tbody',{ref:"table_body",on:{"mouseleave":function($event){return _vm.highlight()}}},_vm._l((_vm.state.features),function(feature,i){return _c('tr',{key:feature.id,class:[
          i % 2 == 1 ? 'odd' : 'pair',
          'feature_attribute',
          { geometry: !!feature.geometry },
          { 'selected': feature.selected }
        ],attrs:{"role":"row"},on:{"mouseover":function($event){return _vm.highlight(feature, false)},"click":function($event){$event.stopPropagation();return _vm.highlight(feature, true)}}},[_c('td',[_c('div',{staticStyle:{"display":"flex"}},[(_vm.show_on_active_filter)?_c('label',{on:{"click":function($event){return _vm.select(feature)}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":feature.selected}})]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top",value:('Form View'),expression:"'Form View'",arg:"top"}],class:'action-button skin-color ' + _vm.$fa('table'),on:{"click":function($event){$event.stopPropagation();return _vm.openForm(feature)}}}),_vm._v(" "),(_vm.layer.state.geolayer && !feature.geometry)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top",value:('This item has no geometry'),expression:"'This item has no geometry'",arg:"top"}],class:'action-button ' + _vm.$fa('alert'),staticStyle:{"color":"currentColor !important"}}):_vm._e(),_vm._v(" "),(_vm.layer.isEditable() && _vm.layer.config.editing.visible)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top",value:('Editing'),expression:"'Editing'",arg:"top"}],class:'action-button skin-color ' + _vm.$fa('pencil'),on:{"click":function($event){$event.stopPropagation();return _vm.editFeature(feature)}}}):_vm._e()])]),_vm._v(" "),_vm._l((_vm.state.headers),function(header,j){return (j > 0)?_c('td',[_c('field',{attrs:{"feature":feature,"state":({ label: undefined, value: feature.attributes[header.name] })}})],1):_vm._e()})],2)}),0)]):_c('div',{directives:[{name:"t",rawName:"v-t",value:('No data'),expression:"'No data'"}],attrs:{"id":"noheaders"}})])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3a485007_0", { source: "#open_attribute_table{margin-top:5px}#g3w-table-toolbar{margin:.755em 1ch 0 0;position:relative;bottom:3px;display:inline-flex;border:1px solid #d2d6de;background-color:#fff;float:left}", map: undefined, media: undefined })
,inject("data-v-3a485007_1", { source: ".geometry[data-v-3a485007]{cursor:pointer}#noheaders[data-v-3a485007]{background-color:#fff;font-weight:700;margin-top:10px}input.form-control.column-search[data-v-3a485007]::placeholder{font-weight:400;font-style:italic}input.form-control.column-search[data-v-3a485007]{height:25px;min-width:40px;padding:2px}#open_attribute_table .action-button[data-v-3a485007]{padding:5px}#g3w-table-toolbar .action-button[data-v-3a485007]{padding:4px}#g3w-table-toolbar .action-button.toggled[data-v-3a485007]{color:#fff!important;background-color:var(--skin-color)}#layer_attribute_table[data-v-3a485007]{width:100%;user-select:none}#layer_attribute_table>tbody>tr[data-v-3a485007]:not(.selected):hover{background-color:rgb(255,255,0,.15)}", map: undefined, media: undefined })
,inject("data-v-3a485007_2", { source: "#g3w-view-content .dataTables_filter{margin-left:auto;margin-right:1ch}#g3w-view-content .dataTables_info{padding-left:.5ch;font-weight:lighter}#open_attribute_table .paginate_button{background:0 0;color:currentColor!important;box-shadow:none}#open_attribute_table .paginate_button.disabled{opacity:.25}#open_attribute_table #layer_attribute_table_length{padding-top:5px}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-3a485007"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Table.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__